import React, { useEffect } from "react";
import Heading from "../ui/Heading";
import Slider from "react-slick";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";

import bypass from "../assets/images/shop-by-style/bypass.png";
import halo from "../assets/images//shop-by-style/halo.png";
import pave from "../assets/images//shop-by-style/pave.png";
import vintage from "../assets/images//shop-by-style/vintage.png";

import arrowleft from "../assets/images/arrow-left-green.png";
import arrowright from "../assets/images/arrow-right-green.png";

const ShopRingByStyle = () => {
  const ringStyles = [
    { name: "Vintage", image: vintage, url: "/ringsettings/style=Vintage" },
    { name: "Pave", image: pave, url: "/ringsettings/style=Pave" },
    { name: "Bypass", image: bypass, url: "/ringsettings/style=Bypass" },
    { name: "Halo", image: halo, url: "/ringsettings/style=Halo" },
  ];

  useEffect(() => {
    const updateTabIndex = () => {
      document
        .querySelectorAll(".slick-slide[aria-hidden='true']")
        .forEach((slide) => {
          slide
            .querySelectorAll("a, button, input, textarea, select")
            .forEach((el) => {
              el.setAttribute("tabindex", "-1");
            });
        });

      document
        .querySelectorAll(".slick-slide[aria-hidden='false']")
        .forEach((slide) => {
          slide
            .querySelectorAll("a, button, input, textarea, select")
            .forEach((el) => {
              el.setAttribute("tabindex", "0");
            });
        });
    };

    // Run on mount
    updateTabIndex();

    // Re-run after a short delay in case of dynamic content
    setTimeout(updateTabIndex, 500);
  }, []);

  let settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: <Image src={arrowleft} alt="left arrow" />,
    nextArrow: <Image src={arrowright} alt=" Rigth arrow" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
    beforeChange: () => {
      setTimeout(() => {
        const slides = document.querySelectorAll(".slick-slide");
        slides.forEach((slide) => {
          const isHidden = slide.getAttribute("aria-hidden") === "true";
          slide
            .querySelectorAll("a, button, input, textarea, select")
            .forEach((el) => {
              el.setAttribute("tabindex", isHidden ? "-1" : "0");
            });
        });
      }, 100); // You can increase this to 300–500ms if needed
    },
  };

  return (
    <section className="shop-ring-by-style">
      <Container fluid className="showcase-container">
        <Heading className="text-md-left text-lg-left text-sm-center text-center">
          <h2>Shop Engagement Rings By Style</h2>
          <p>Discover a stunning collection of engagement rings</p>
        </Heading>

        <Row>
          <Col sm={12} md={12} lg={12}>
            <Slider {...settings2}>
              {ringStyles.map((ring, index) => (
                <div className="item_outerr_ring_style">
                  <div className="item" key={index}>
                    <Link to={ring.url}>
                      <Image src={ring.image} alt={`${ring.name} Ring`} />
                    </Link>
                    <Link to={ring.url}>{ring.name}</Link>
                  </div>
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ShopRingByStyle;
